import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ColorPaper } from '@/components/ui/Surface/ColorPaper';
import { InfoOutlineIcon, WarningAmberIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
const borderColor = {
    info: 'border-blue-gray-75',
    warn: 'border-orange-100',
};
const bgColor = {
    info: 'info',
    warn: 'emphasis',
};
export const InlineAlert = (props) => {
    const { align = 'start', children, className = '', isBold = false, size = 'sm', space = 'normal', variant, } = props;
    return (_jsx(ColorPaper, Object.assign({ bgColor: bgColor[variant], className: clsx('border border-solid', borderColor[variant], className) }, { children: _jsxs(IconTextGroup, Object.assign({ align: align, space: space }, { children: [variant === 'info' && _jsx(InfoOutlineIcon, { color: 'info', size: size }), variant === 'warn' && (_jsx(WarningAmberIcon, { color: 'secondary', size: size })), _jsx(Text, Object.assign({ className: 'w-full self-center', color: 'base', isBold: isBold, size: 'sm' }, { children: children }))] })) })));
};
